import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'
import { unwrapList } from '../lib/unwrap'

export interface TwinDevice {
  device_id: string
  tenant_id: string
  status: string
  last_latitude?: number | null
  last_longitude?: number | null
  last_speed?: number | null
  last_heading?: number | null
  last_altitude?: number | null
  last_seen_at?: string | null
  health_score: number
  sensor_data: Record<string, unknown>
  updated_at: string
}

export function useTwinDevices() {
  return useQuery({
    queryKey: ['digital-twin'],
    queryFn: () => api.get('/twin/devices').then((r) => unwrapList<TwinDevice>(r.data)),
    refetchInterval: 10_000,
  })
}

export function useTwinDevice(id: string) {
  return useQuery({
    queryKey: ['digital-twin', id],
    queryFn: () => api.get<TwinDevice>(`/twin/devices/${id}`).then((r) => r.data),
    enabled: !!id,
    refetchInterval: 5_000,
  })
}
